import React from "react";
import { useDispatch, useSelector } from "react-redux";
import HelpButton from "../HelpContent/HelpButton";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import OnewayIcon from "../../assets/icons/icon_1_way-01.svg2";
import TwowayIcon from "../../assets/icons/icon_2_way-01.svg2";
import AiIcon from "../../assets/icons/Icon_Library/application icons/library/boomAI_icon.svg2";
import MyIcon from "../Common/MyIcon";
import { selectBroadcast, setBroadcast } from "../store/slices/broadcastSlice";
import MyModal from "../Common/MyModal";
import AiModal from "./AiModal";
import { useConfirmDialog } from "../Builder/Components/ConfirmDialogContext";

export default function BroadcastMethodSelector({ confirmFixedBroadcast }) {
  const values = useSelector(selectBroadcast);
  const dispatch = useDispatch();
  const confirmDialog = useConfirmDialog();
  const setValues = (f) => dispatch(setBroadcast(f(values)));

  return (
    <div className="bg-purple-gradient p-2 rounded-3 d-flex justify-content-between">
      <div className="fw-bold m-2 text-navy">
        Broadcast method: <HelpButton helpKey="broadcast-method" />
      </div>
      <div className="ms-3">
        <Input
          value={[values.CommsMethod]}
          onChange={async (v) => {
            if (
              v[0] === "one-way" &&
              (values.Handlers || []).filter((h) => !h.IsDeliveryStatus)
                .length > 0 &&
              !(await confirmDialog(
                "Are you sure?",
                "You have reply handlers in the broadcast. If you switch to one-way method, you will lose your reply handlers."
              ))
            ) {
              return;
            }
            confirmFixedBroadcast(() =>
              setValues((prev) => ({
                ...prev,
                CommsMethod: v[0],
                ...(v[0] === "one-way"
                  ? {
                      Handlers: (prev.Handlers || []).filter(
                        (h) => h.IsDeliveryStatus
                      ),
                    }
                  : {}),
              }))
            );
          }}
          inputType="radio"
          radioName="CommsMethod-radio"
          options={[
            { value: "one-way", label: "ONE-WAY" },
            { value: "two-way", label: "TWO-WAY" },
          ]}
        />
      </div>
      <div>
        {values.CommsMethod === "one-way" ? (
          <div className="mx-4 d-flex align-items-stretch">
            <MyIcon Icon={OnewayIcon} width={25} />
            <div className="ms-2">
              <span className="text-navy fw-bold">ONE-WAY </span>
              <div className="text-secondary small">
                Send one-way broadcast with replies disabled.
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className="mx-4 d-flex">
              <MyIcon Icon={TwowayIcon} width={25} />
              <div className="ms-2">
                <span className="text-navy fw-bold">TWO-WAY </span>
                <div className="text-secondary small">
                  Send two-way broadcast with replies enabled.
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      ></div>
    </div>
  );
}
